import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_EncounterSnapshot = {
    _v1: {
        getEncounterSnapshotsByFilters: { method: HttpMethod.POST, path: '/v1/get-encounter-snapshots-by-filters' },
        createEncounterSnapshot: { method: HttpMethod.POST, path: '/v1/create-encounter-snapshot' },
    }
};
//# sourceMappingURL=api-def.js.map